import { useAnalyticsContext } from 'analytics/hooks'
import { FC } from 'react'
import { InternalUploadFileButton, UploadFileButtonProps } from './InternalUploadFileButton'

export const AUploadFileButton: FC<UploadFileButtonProps & { eventName: string }> = ({
  onUpload,
  accept,
  text,
  icon,
  size,
  color,
  background,
  multiple,
  progress,
  eventName,
}) => {
  const { track } = useAnalyticsContext()

  const uploadHandler = (files: File | File[]) => {
    onUpload(files)

    track(`upload|${eventName}`)
  }

  return (
    <InternalUploadFileButton
      onUpload={uploadHandler}
      text={text}
      progress={progress}
      multiple={multiple}
      icon={icon}
      color={color}
      background={background}
      size={size}
      accept={accept}
    />
  )
}
